
export const RESULT_RECEIVED = 'RESULT_RECEIVED';

export const receive = (error, result, orderIntent, threeDsAuthenticationResult, paymentInstrument, executeRequired, product) => (dispatch) => {
  dispatch({type: RESULT_RECEIVED, error, result, orderIntent, threeDsAuthenticationResult, paymentInstrument, executeRequired, product});
};



// WEBPACK FOOTER //
// ./src/result/ResultActions.js